<lu-modal [options]="modalOptions">
	<div class="tooltip-cnt" [innerHTML]="options.message"></div>
</lu-modal>
